import { render, staticRenderFns } from "./termo-declaracao-concordancia.vue?vue&type=template&id=2ceca946&scoped=true"
import script from "./termo-declaracao-concordancia.vue?vue&type=script&lang=js"
export * from "./termo-declaracao-concordancia.vue?vue&type=script&lang=js"
import style0 from "./termo-declaracao-concordancia.vue?vue&type=style&index=0&id=2ceca946&prod&scoped=true&lang=css"
import style1 from "./termo-declaracao-concordancia.vue?vue&type=style&index=1&id=2ceca946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceca946",
  null
  
)

export default component.exports